import { createFileRoute } from "@tanstack/react-router";

import { OccasionLanding } from "../components/landing/occasion-landing";
import { seo } from "../lib/head";
import { OCCASION_PAGES } from "../lib/occasion-pages";

export const Route = createFileRoute("/liste-de-noel")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: OCCASION_PAGES.christmas.seoTitle,
      description: OCCASION_PAGES.christmas.seoDescription,
      image: OCCASION_PAGES.christmas.ogImage,
    }),
  component: () => <OccasionLanding occasion="christmas" />,
});
